<template>
    <div class="detail-content school_business nqt__custom_course__online" :class="{nqt__mb: mobile}">
        <div class="primarylists list-mobile" v-if="mobile">
            <div class="titles clear title_mobile">
                <img src="../../../static/images/icon-st.jpg" alt="" />
                <div class="title l">{{$t('comments.commentName')}}</div>
            </div>
        </div>
        <div class="nqt__header__cmt" v-if="!mobile">
            <!-- <i class="nqt__icon el-icon-share"></i> -->
            <span>{{$t('comments.commentName')}}</span>
            <div class="nqt__status__cmt" @click="status = !status">
                <span class="menu-switch-school" :value="status" :class="{ 'menu-switch-school-on': status }"></span>
                <p>{{$t('comments.titleStatus')}}</p>
            </div>
        </div>
        <!-- PC -->
        <div v-if="!mobile">
            <el-table :data="dataTable" style="width: 100%" class="nqt__pc_table__online">
                <el-table-column :label="$t('js.no')" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="courseName" :label="$t('home.courseName')"></el-table-column>
                <el-table-column prop="lessonName" :label="$t('comments.content')"></el-table-column>
                <el-table-column prop="totalNewMessage" align="center" header-align="center" :label="$t('comments.countConv')"></el-table-column>
                <el-table-column prop="timeSeen" :label="$t('comments.timeSeen')"></el-table-column>
                <el-table-column fixed="right" align="center" header-align="center" :label="$t('comments.detail')" width="120">
                    <template slot-scope="scope"> 
                        <el-button @click="show(scope.row)" type="primary" plain size="mini">{{$t('manage.look')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- MB -->
        <div class="cst__mb" v-if="mobile">
            <div class="nqt__status__cmt__mb" @click="status = !status">
                <span class="menu-switch-school" :value="status" :class="{ 'menu-switch-school-on': status }"></span>
                <p>{{$t('comments.titleStatus')}}</p>
            </div>
        </div>
        <div class="course_box_mobile" v-if="mobile && dataTable.length > 0">
            <div class="box-1" v-for="(item, index) in dataTable" :key="item.value">
                <div @click="activeID = activeID == index ? null : index" class="title_course_box" :class="{'turn-arrow': activeID == index}">
                    <div class="title_course">{{ item.courseName }}</div>
                </div>
                <div class="content_box" :class="{'active-content': activeID == index}">
                    <div class="content_new">
                        <h1>{{$t('comments.content')}}:</h1>
                        <span>{{ item.lessonName }}</span>
                    </div>
                    <div class="content_new">
                        <h1>{{$t('comments.countConv')}}:</h1>
                        <span>{{ item.totalNewMessage }}</span>
                    </div>
                    <div class="content_new">
                        <h1>{{$t('comments.timeSeen')}}:</h1>
                        <span>{{ item.timeSeen }}</span>
                    </div>
                    <div class="btn-course" @click="show(item)">
                        <el-button type="text" size="small">
                            <span class="nqt__mb__btn">{{$t('manage.look')}}</span>
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data: [],
                initial: true,
                status: false,
                activeID: null,
            };
        },
        methods: {
            getCourseCommentListNew: function () {
                return new Promise((resolve, reject) => {
                    this.$api
                    .post("/courseStudy/getCourseCommentListNew", {
                        userId: this.userId
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {reject(err.response)});
                });
            },
            show: async function (data) {
                var  outlineInfo = {
                    activeMenu: null,
                    activeID: null,
                    courseId: null,
                    item: 'MESSENGER'
                }
                outlineInfo.activeMenu = await this.getCourseMaterialNew();
                outlineInfo.activeID = data.lessonId;
                outlineInfo.courseId = data.courseId;
                this.$router.push({
                    path: "/home/curriculum/lesson",
                    query: {
                        outlineInfo: JSON.stringify(outlineInfo)
                    }
                })
            },
            getCourseMaterialNew: function (lessonId) {
                return new Promise((resolve, reject) => {
                    this.$api
                    .post("/courseStudy/getCourseMaterialNew", {
                        courseOutlineId: lessonId,
                        languageType: this.$lang(),
                    })
                    .then((response) => {
                        resolve(response.data.l1);
                    })
                    .catch((err) => {reject(err.response)});
                });
            }
        },
        async created () {
            this.userId = this.$attrs.userId || window.sessionStorage.getItem("id");
            this.data = await this.getCourseCommentListNew();
        },
        computed: {
            dataTable () {
                if (this.status) {
                    return this.data;
                }
                return this.data.filter(item => item.status == 0);
            },
            mobile () {
                return this.$store.getters['header/mobile'];
            }
        }
    };
</script>
<style scoped>
    .nqt__header__cmt {
        display: flex;
        position: relative;
    }
    .nqt__header__cmt .nqt__icon{
        font-size: xx-large;
    }
    .nqt__header__cmt span{
        margin-left: 5px;
        align-self: center;
        font-size: 24px;
        font-weight: 700;
    }
    .nqt__status__cmt {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        cursor: pointer;
    }
    .nqt__status__cmt p {
        align-self: center;
        font-size: 18px;
        margin-left: 5px;
    }
    .menu-switch-school {
        display: block;
        position: relative;
        width: 46px;
        height: 27px;
        border: 1px solid #dfdfdf;
        outline: 0;
        border-radius: 16px;
        box-sizing: border-box;
        background-color: #dfdfdf;
        transition: background-color 0.1s, border 0.1s;
        cursor: pointer;
    }
    .menu-switch-school:before {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 44px;
        height: 25px;
        border-radius: 15px;
        background-color: #fdfdfd;
        transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
    }
    .menu-switch-school:after {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 24px;
        height: 24px;
        border-radius: 15px;
        background-color: #ffffff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
        transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
    }
    .menu-switch-school-on {
        border-color: #79c9ff;
        background-color: #79c9ff;
    }
    .menu-switch-school-on:before {
        border-color: #79c9ff;
        background-color: #79c9ff;
    }
    .menu-switch-school-on:after {
        transform: translateX(20px);
    }
    .title_mobile {
        left: 10px !important;
    }
    .cst__mb .nqt__status__cmt__mb p {
        font-size: 11px;
        padding-left: 6px;
    }
    .cst__mb .nqt__status__cmt__mb {
        display: flex;
        cursor: pointer;
    }
    .cst__mb {
        width: 100%;
        padding: 20px;
        margin: 0 auto;
        padding: 10px;
    }
    .nqt__mb__btn {
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/comments/list.vue